export const calculateEngagementLevel = (ePulseData) => {
  if (!ePulseData || ePulseData.length === 0) {
    return "no-data";
  }

  const validData = ePulseData.filter(
    (item) => item && item.pulse !== null && item.pulse !== undefined
  );

  if (validData.length === 0) {
    return "no-data";
  }

  // Only show engagement level when we have enough data points
  if (validData.length < 2) {
    return "no-data";
  }

  const latestData = validData[validData.length - 1];
  const pulseValue = latestData.pulse;

  if (typeof pulseValue !== "number") {
    return "no-data";
  }

  // Map pulse values (-50 to +50) to engagement levels
  // Based on chart: High=50, Med=0, Low=-50
  if (pulseValue > 0) {
    return "high";
  } else if (pulseValue >= -40) {
    return "medium";
  } else {
    return "low";
  }
};

export const getEngagementPercentage = (pulseValue) => {
  if (pulseValue === null || pulseValue === undefined) {
    return null;
  }

  return Math.round(((pulseValue + 50) / 100) * 100);
};
